export enum FallbackFilterEnum {
  FlowKPI = 'Flow KPI',
  PressureKPI = 'Pressure KPI',
  CompressorFailure = 'Compressor Failure',
}

export enum ModeOfFallbackCreation {
  Custom = 'custom',
  Existing = 'existing',
}

export enum NewFallbackButtonType {
  Primary = 'primary',
  Default = 'default',
}

export enum NewFallbackStep {
  Filters = 'filters',
  TableSelection = 'table-selection',
}

export enum NewFallbackColumnsNameEnum {
  Order = 'order',
  Load = 'load',
  VsdTarget = 'vsdTarget',
  Unload = 'unload',
  AutoStop = 'autoStop',
  ImmediateStop = 'immediateStop',
  Modulate = 'modulate',
  BandConfiguration = 'bandConfiguration',
  PressureDrop = 'pressureDrop',
}

export enum ConditionAction {
  Field = 'field',
  Value = 'value',
  Remove = 'remove',
}
